<template>
	<div class="form">
		<div class="form-title">
			<p>Esqueci minha senha</p>
		</div>
		<div class="form-subtitle">
			<p>
				Digite abaixo o seu e-mail associado a sua conta para que possamos enviar um link para
				mudança de senha:
			</p>
		</div>
		<div class="form-field">
			<label class="form-field__label" for="login"> Conta: </label>
			<input
				:class="emailRequired || wrongFormat ? 'alert' : ''"
				class="form-field__input"
				placeholder="email@email.com.br"
				type="text"
				name="login"
				id="login-input"
				v-model="email"
				autocomplete="off"
				@input="emailRequired = false"
			/>
			<small class="form-field__input--required" v-if="wrongFormat"> E-mail inválido. </small>
			<small class="form-field__input--required" v-show="emailRequired"> Campo obrigatório. </small>
		</div>
		<div class="form-action">
			<button class="form-action__btn outline" @click="goToLogin()">Voltar</button>
			<button
				class="form-action__btn"
				:class="isLoadingSendEmail ? 'disabled' : ''"
				@click="sendEmail()"
			>
				<span v-if="!isLoadingSendEmail">Próximo</span>
				<SpinnerIcon :color="'white'" v-else />
			</button>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SEND_NEW_PASSWORD } from '@/store/modules/login/forgotPassword/actions';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';

export default {
	name: 'ForgotForm',
	components: { SpinnerIcon },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		email: null,
		emailRequired: false,
		wrongFormat: false,
	}),
	mounted() {},
	methods: {
		...mapActions('forgotPassword', {
			sendNewPassword: SEND_NEW_PASSWORD,
		}),
		validateEmail(email) {
			let emailRegex = /\S+@\S+\.\S+/;
			return emailRegex.test(email);
		},
		sendEmail() {
			this.emailRequired = false;
			this.wrongFormat = false;

			if (!this.email) {
				this.emailRequired = true;
				return;
			}

			if (!this.validateEmail(this.email)) {
				this.wrongFormat = true;
				return;
			}

			const body = {
				email: this.email.trim(),
			};

			this.sendNewPassword({ body: body, vm: this }).then((res) => {
				if (res.status == 201) {
					this.$emit('handleSuccess');
				}
			});
		},
		expiredCaptcha() {
			this.captcha = false;
		},
		verifyCaptcha() {
			this.captchaRequired = false;
			this.captcha = true;
		},
		goToLogin() {
			this.$emit('handleForgotForm');
		},
	},
	computed: {
		...mapGetters('forgotPassword', ['isLoadingSendEmail']),
	},
};
</script>

<style lang="scss" scoped>
@import 'ForgotForm.scss';
</style>
